import { APP_BACKGROUND_COLOR,APP_HOVER_COLOR, FONT_FAMILY } from "../../theme";

export const styles = {
  skipButton: {
    fontFamily: FONT_FAMILY,
    color: "white",
    textTransform: "none",
    textDecoration: "underline",
    fontSize: "15px",
    backgroundColor: APP_BACKGROUND_COLOR,
    padding: "8px 10px",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  selectOptionHeading : {
    fontFamily: FONT_FAMILY,
    fontSize: "28px",
    fontWeight: "bold",
    textAlign: "center",
  }as const,
  minorSubscriptionButtonContainer :{
    display: "flex",
    justifyContent: "center",
    marginTop: "50px",
    marginBottom: "20px",
  }as const
};
